import React from 'react';
import { Select, Tooltip } from 'antd';
import FormItem from './FormItem';

const { Option } = Select;

const BaseSelect = ({
  form,
  items,
  loading,
  label,
  name,
  rules,
  contentKey = 'name',
  valueKey = 'id',
  initialValue,
  disabled,
}) => {
  const { getFieldDecorator } = form;

  return (
    <Tooltip placement='bottom' title={disabled ? 'Для редактирования данных измените статус счетчика' : ''}>
    <FormItem label={label}>
      {getFieldDecorator(name, {
        initialValue: loading ? undefined : initialValue || undefined,
        rules,
      })(
        <Select placeholder="Выберите из списка" loading={loading} disabled={disabled}>
          {items?.length &&
            items.map((item) => (
              <Option key={item[valueKey]} value={item[valueKey]}>
                {item[contentKey]}
              </Option>
            ))}
        </Select>
      )}
    </FormItem>
    </Tooltip>
  );
};

export default BaseSelect;
